// @flow

import * as React from 'react';

type Props = {
  page: number,
  children: React.Node,
  onClick?: (newPage: number) => mixed,
  ...
};

class PaginationLink extends React.Component<Props> {
  render(): React.Node {
    const { page: _a, children: _b, ...otherProps } = this.props;

    return (
      <a {...otherProps} onClick={this._onClick}>
        {this.props.children}
      </a>
    );
  }

  _onClick: (evt: SyntheticEvent<HTMLAnchorElement>) => void = (
    evt: SyntheticEvent<HTMLAnchorElement>
  ) => {
    const { onClick } = this.props;
    if (!onClick) return;

    evt.preventDefault();
    onClick(this.props.page);
  };
}

export default PaginationLink;
